import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {ProtectedRoute} from './protected.route'

import '../src/componentes2/css/leaflet.css';
import '../src/componentes2/css/bootstrap.min.css';
import '../src/componentes2/css/mmenu.css';
import '../src/componentes2/css/mburger.css';
import '../src/componentes2/css/leaflet.css';
import '../src/componentes2/css/style.css';

import Mapa from "./componentes2/mapa/Mapa";
import Login from "./componentes2/login/Login2";
//dashboard-1
import Dashboard from './componentes2/dashboard/Dashboard';
import Lecturas from './componentes2/dashboard/lecturas/Lecturas';
import Informacion from './componentes2/dashboard/informacion/Informacion';
import Graficas from './componentes2/dashboard/graficas/Graficas';
import Volumen from './componentes2/dashboard/volumen/Volumen';
//admin
import ModSitios from './componentes2/admin/modsitios/Sitios.js';
import ModEquipos from './componentes2/admin/modequipos/Equipos.js';
import ModNorma from './componentes2/admin/modNormaC/ConfNorC.js';


function App() {
  return (
    <Router>
    <Switch>
      <Route path="/" exact component={Login} />
      <ProtectedRoute path="/mapa" exact component={Mapa} />
      <ProtectedRoute path="/dashboard/1/:id" exact component={Dashboard} />
      <ProtectedRoute path="/lecturas/1/:id" exact component={Lecturas} />
      <ProtectedRoute path="/informacion/1/:id" exact component={Informacion} />
      <ProtectedRoute path="/graficas/1/:id" exact component={Graficas} />      
      <ProtectedRoute path="/volumen/1/:id" exact component={Volumen} />      
      <ProtectedRoute path="/admin/modsitios/" exact component={ModSitios} />
      <ProtectedRoute path="/admin/modequipos/" exact component={ModEquipos} />
      <ProtectedRoute path="/admin/modnormac/" exact component={ModNorma} />

      <Route path="*" component={()=>{"404 NOT FOUND"}}/>
      </Switch>
      </Router>
    
  );
}

export default App;
